<template>
    <div>
        <v-toolbar dense class="mb-3 secondary" elevation="1" rounded>
            <v-breadcrumbs large :items="[
                { text: 'Sales and Distribution' },
                { text: 'Reports' },
                { text: 'Payment Summary Report' },
            ]"> </v-breadcrumbs>
        </v-toolbar>
        <v-sheet elevation="1" rounded>
            <v-toolbar flat class="secondary">
                <v-toolbar-title>
                    Payment Details Report
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <div class="mx-4" v-if="dirty">
                    <v-chip>{{this.from}}</v-chip>
                    <span class="mx-2">to</span>
                    <v-chip>{{this.to}}</v-chip>
                </div>
                <v-divider vertical v-if="dirty"></v-divider>
                <v-toolbar-items>
                    <v-btn icon @click="refresh" :loading="loading" v-if="dirty">
                        <v-icon>mdi-refresh</v-icon>
                    </v-btn>
                    <v-btn depressed color="primary" @click="searchDialog = true">
                        <v-icon left>mdi-magnify</v-icon>
                        search
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-divider></v-divider>
            <PaymentDetailsReportTable/>
        </v-sheet>
        <v-dialog scrollable width="400" v-model="searchDialog">
            <v-card>
                <v-card-title>
                    Search Payment Report
                </v-card-title>
                <v-card-text>
                    <div class="pt-2">
                        <v-form ref="form">
                            <v-row>
                                <v-col>
                                    <PDatePicker
                                        label="from"
                                        v-model="form.from"
                                        outlined
                                        hide/>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <PDatePicker
                                        label="to"
                                        outlined
                                        v-model="form.to"
                                        hide/>
                                </v-col>
                            </v-row>
                        </v-form>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-row no-gutters>
                        <v-col class="me-1">
                            <v-btn block depressed color="primary" @click="submit" :loading="loading">
                                submit
                            </v-btn>
                        </v-col>
                        <v-col class="ms-1">
                            <v-btn block text color="primary" @click="searchDialog = false">
                                cancel
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="snackbar.value" :color="snackbar.color">{{snackbar.text}}</v-snackbar>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import PaymentDetailsReportTable from './../../components/Sales/PaymentDetailsReportTable';
import PDatePicker from './../../components/common/PDatePicker';
import moment from 'moment';

export default {
    name: "PaymentDetailsReportView",
    components: {
        PaymentDetailsReportTable,
        PDatePicker
    },
    data() {
        return {
            searchDialog: false,
            dirty: false,
            form: {
                from: null,
                to: null
            },
            snackbar: {
                value: false,
                text: "",
                color: ""
            }
        }
    },
    computed: {
        ...mapGetters("sales/reports/paymentDetails", [
            "loading", "from", "to", "data"
        ])
    },
    methods: {
        ...mapActions("sales/reports/paymentDetails", [
            "get", "updateParams"
        ]),
        submit() {
            if(!this.$refs.form.validate()) return;
            this.updateParams(this.form).then(() => {
                this.dirty = true
            }).catch(error => {
                let message = error.response ? error.response.data.message : error;
                this.snackbar = { value: true, color: "error", text: message }
            }).finally(() => {
                this.searchDialog = false;
            });
        },
        refresh() {
            this.get();
        }
    },
    mounted() {
        if(this.data.length > 0) {
             this.dirty = true;
             this.form.from = this.from;
             this.form.to = this.to;
             return;
        }
        this.form.from = moment().format("YYYY-MM-DD");
        this.form.to = moment().format("YYYY-MM-DD");
    }
}
</script>

<style>

</style>